const ACTIVE_UPLOAD_STATUSES = ["uploading", "processing"]

export const uploads = (state) => state.uploads

export const uploadFor = (state) => (episodeKey) => (episodeKey ? state.uploads[episodeKey] ?? null : null)

export const isUploadActive = (state) => (episodeKey) =>
  ACTIVE_UPLOAD_STATUSES.includes(state.uploads[episodeKey]?.status)

export const hasActiveUploads = (state) =>
  Object.values(state.uploads).some((upload) => ACTIVE_UPLOAD_STATUSES.includes(upload.status))
